module.exports = __webpack_public_path__ + "static/img/js.07f02bf4.png";